import React, { useEffect, useRef, useState } from "react";
import Seek from "src/pages/seek/index";

import _ from "lodash";
interface SearchProps {
  question? : string;
  onClose: () => void;
  seekAnswer?: string;
  isLimitExceeded?:boolean;
}
const SeekSearch: React.FC<SearchProps> = ({ question, onClose, seekAnswer ,isLimitExceeded}) => {
  return (
      <Seek
        onClose={() => onClose()}
        initialQuery={question}
        seekAnswer={seekAnswer}
        isLimitExceeded={isLimitExceeded}
      />
  );
};

export default SeekSearch;
